<div
  style="page-break-inside: avoid;"
  class="mt-4"
  *ngIf="incomeFormFinancialAssetsData.length > 0"
  [ngClass]="{
    'container': true,
    'return-view-background-print': printActive,
    'return-view-background': !printActive
  }"
>
  <div class="row mb-4">
    <div class="col-12 text-center">
      <strong>PARTICULARS OF INCOME FROM FINANCIAL ASSETS</strong>
    </div>
  </div>

  <div class="row">
    <div class="col-sm-6">
      <strong>Taxpayer Name:</strong> {{ returnData?.profileData?.assesName }}
    </div>
    <div class="col-sm-6 text-right">
      <strong>Assessment Year:</strong> {{ returnData?.submissionInfo?.assessmentYear }}
    </div>
  </div>

  <div class="row mt-3 mb-5">
    <div class="col-sm-12">
      <strong>TIN</strong>
      <span class="ml-3" style="white-space: nowrap;">
        <input
          value="{{ tinChar }}"
          *ngFor="let tinChar of ((returnData?.profileData?.tin || '') + '').split('')"
          class="input-default"
          disabled
        />
      </span>
    </div>
  </div>

  <ng-container *ngFor="let item of incomeFormFinancialAssetsData; let idx = index">
    <!-- SRO / sro_income: keep particulars / amount table; each detail is a separate block -->
    <ng-container *ngIf="isSroStyleType(item?.iisTypeName)">
      <ng-container *ngFor="let detail of getInterestSecurityDetails(item); let detailIdx = index">
        <div style="page-break-inside: avoid;" class="row mb-5">
          <div class="col-12 return-view-section-title mb-3">
            {{ getFinancialAssetTypeTitle(item?.iisTypeName) }}
          </div>
          <div class="col-12 mb-3">
            <div class="return-view-text-fields">
              <div class="return-view-text-field">
                <span class="return-view-text-label">Financial Assets Type:</span>
                <span class="return-view-text-value">{{ getFinancialAssetTypeTitle(item?.iisTypeName) }}</span>
              </div>
              <div class="return-view-text-field" *ngFor="let field of getSroTextParticulars(detail, item?.iisTypeName)">
                <span class="return-view-text-label">{{ field.title }}:</span>
                <span class="return-view-text-value">{{ getValue(detail, field.key) }}</span>
              </div>
            </div>
          </div>

          <div class="col-12">
            <table class="table table-bordered income-financial-assets-sro-table">
              <thead>
                <tr class="text-center">
                  <th style="width: 70%">Particulars</th>
                  <th style="width: 30%">Amount</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let particular of getSroAmountParticulars(item?.iisTypeName)">
                  <ng-container *ngIf="hasSroAmountValue(item, detail, particular)">
                    <td>{{ getSroAmountTitle(particular, item?.iisTypeName) }}</td>
                    <td class="text-right pr-3">{{ getSroAmountValue(item, detail, particular) | currencySeparatorBD }}</td>
                  </ng-container>
                </tr>
                <tr *ngFor="let particular of parentAmountParticulars">
                  <ng-container *ngIf="!isSroIncomeType(item?.iisTypeName) && detailIdx === 0 && hasValue(item, particular.key)">
                    <td>{{ particular.title }}</td>
                    <td class="text-right pr-3">{{ getValue(item, particular.key) | currencySeparatorBD }}</td>
                  </ng-container>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </ng-container>
    </ng-container>

    <!-- Non-SRO: multi-column table views -->
    <ng-container *ngIf="!isSroStyleType(item?.iisTypeName) && getInterestSecurityDetails(item).length">
      <div style="page-break-inside: avoid;" class="row mb-5">
        <div class="col-12 return-view-section-title mb-3">
          {{ getFinancialAssetTypeTitle(item?.iisTypeName) }}
        </div>

        <!-- Sanchayapatra -->
        <div class="col-12" *ngIf="isSanchayapatraType(item?.iisTypeName)">
          <table class="table table-bordered income-financial-assets-table">
            <thead>
              <tr class="text-center">
                <th></th>
                <th>Scheme Name</th>
                <th>Registration No</th>
                <th>Issue Date</th>
                <th>Value</th>
                <th>Gross Interest</th>
                <th>TDS</th>
                <th>Encashed</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let detail of getInterestSecurityDetails(item); let i = index">
                <td class="text-center">{{ i + 1 }}</td>
                <td>{{ getValue(detail, 'schemeName') }}</td>
                <td>{{ getValue(detail, 'registrationNo') }}</td>
                <td>{{ getValue(detail, 'dateOfIssue') }}</td>
                <td class="text-right pr-3">{{ getValue(detail, 'value') | currencySeparatorBD }}</td>
                <td class="text-right pr-3">{{ getValue(detail, 'grossInterest') | currencySeparatorBD }}</td>
                <td class="text-right pr-3">{{ getValue(detail, 'deductedTax') | currencySeparatorBD }}</td>
                <td class="text-center">{{ isEncashed(detail) ? 'Yes' : 'No' }}</td>
              </tr>
              <tr class="font-weight-bold">
                <td class="text-center" colspan="4">Total</td>
                <td class="text-right pr-3">{{ getDetailsTotal(getInterestSecurityDetails(item), 'value') | currencySeparatorBD }}</td>
                <td class="text-right pr-3">{{ getDetailsTotal(getInterestSecurityDetails(item), 'grossInterest') | currencySeparatorBD }}</td>
                <td class="text-right pr-3">{{ getDetailsTotal(getInterestSecurityDetails(item), 'deductedTax') | currencySeparatorBD }}</td>
                <td></td>
              </tr>
            </tbody>
          </table>
          <!-- <div class="mt-2" *ngIf="hasValue(item, 'totalExpense')">
            <strong>Related Expenses:</strong> {{ getValue(item, 'totalExpense') | currencySeparatorBD }}
          </div> -->
        </div>

        <!-- Bank/FI -->
        <div class="col-12" *ngIf="isBankFiType(item?.iisTypeName)">
          <table class="table table-bordered income-financial-assets-table">
            <thead>
              <tr class="text-center">
                <th></th>
                <th>Name of Bank/FI</th>
                <th>Account Type</th>
                <th>Branch Name</th>
                <th>Account No</th>
                <th>Gross Interest</th>
                <th>Related Fees/<br/>Charges</th>
                <th>Net Income</th>
                <th>TDS</th>
                <th>Year End Balance</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let detail of getInterestSecurityDetails(item); let i = index">
                <td class="text-center">{{ i + 1 }}</td>
                <td>{{ getValue(detail, 'nameOfParticular') || getValue(detail, 'bondName') }}</td>
                <td>{{ getValue(detail, 'accountType') }}</td>
                <td>{{ getValue(detail, 'branchName') }}</td>
                <td>{{ getValue(detail, 'registrationNo') }}</td>
                <td class="text-right pr-3">{{ getValue(detail, 'grossInterest') | currencySeparatorBD }}</td>
                <td class="text-right pr-3">{{ getValue(detail, 'relatedExpenses') | currencySeparatorBD }}</td>
                <td class="text-right pr-3">{{ getNetIncome(detail) | currencySeparatorBD }}</td>
                <td class="text-right pr-3">{{ getValue(detail, 'deductedTax') | currencySeparatorBD }}</td>
                <td class="text-right pr-3">{{ getValue(detail, 'yearEndBalance') | currencySeparatorBD }}</td>
              </tr>
              <tr class="font-weight-bold">
                <td class="text-center" colspan="5">Total</td>
                <td class="text-right pr-3">{{ getDetailsTotal(getInterestSecurityDetails(item), 'grossInterest') | currencySeparatorBD }}</td>
                <td class="text-right pr-3">{{ getDetailsTotal(getInterestSecurityDetails(item), 'relatedExpenses') | currencySeparatorBD }}</td>
                <td class="text-right pr-3">{{ getDetailsTotalNetIncome(getInterestSecurityDetails(item)) | currencySeparatorBD }}</td>
                <td class="text-right pr-3">{{ getDetailsTotal(getInterestSecurityDetails(item), 'deductedTax') | currencySeparatorBD }}</td>
                <td class="text-right pr-3">{{ getDetailsTotal(getInterestSecurityDetails(item), 'yearEndBalance') | currencySeparatorBD }}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Treasury Bond -->
        <div class="col-12" *ngIf="isTreasuryBondType(item?.iisTypeName)">
          <table class="table table-bordered income-financial-assets-table">
            <thead>
              <tr class="text-center">
                <th></th>
                <th>Bank/FI/<br/>Company Name</th>
                <th>Account Type</th>
                <th>Bank Branch/<br> Company Name <br> (for SUKUK/Other Securities)</th>
                <th>Account/<br/>Instrument/<br/>(ISIN)/BOID</th>
                <th>Gross Interest/<br/>Profit</th>
                <th>Related Fees/<br/>Charges</th>
                <th>Net Income</th>
                <th>TDS</th>
                <th>Year End Balance</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let detail of getInterestSecurityDetails(item); let i = index">
                <td class="text-center">{{ i + 1 }}</td>
                <td>{{ getValue(detail, 'nameOfParticular') || getValue(detail, 'bondName') }}</td>
                <td>{{ getValue(detail, 'accountType') }}</td>
                <td>{{ getValue(detail, 'branchName') }}</td>
                <td>{{ getValue(detail, 'registrationNo') }}</td>
                <td class="text-right pr-3">{{ getValue(detail, 'grossInterest') | currencySeparatorBD }}</td>
                <td class="text-right pr-3">{{ getValue(detail, 'relatedExpenses') | currencySeparatorBD }}</td>
                <td class="text-right pr-3">{{ getNetIncome(detail) | currencySeparatorBD }}</td>
                <td class="text-right pr-3">{{ getValue(detail, 'deductedTax') | currencySeparatorBD }}</td>
                <td class="text-right pr-3">{{ getValue(detail, 'yearEndBalance') | currencySeparatorBD }}</td>
              </tr>
              <tr class="font-weight-bold">
                <td class="text-center" colspan="5">Total</td>
                <td class="text-right pr-3">{{ getDetailsTotal(getInterestSecurityDetails(item), 'grossInterest') | currencySeparatorBD }}</td>
                <td class="text-right pr-3">{{ getDetailsTotal(getInterestSecurityDetails(item), 'relatedExpenses') | currencySeparatorBD }}</td>
                <td class="text-right pr-3">{{ getDetailsTotalNetIncome(getInterestSecurityDetails(item)) | currencySeparatorBD }}</td>
                <td class="text-right pr-3">{{ getDetailsTotal(getInterestSecurityDetails(item), 'deductedTax') | currencySeparatorBD }}</td>
                <td class="text-right pr-3">{{ getDetailsTotal(getInterestSecurityDetails(item), 'yearEndBalance') | currencySeparatorBD }}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Dividend -->
        <div class="col-12" *ngIf="isDividendType(item?.iisTypeName)">
          <table class="table table-bordered income-financial-assets-table">
            <thead>
              <tr class="text-center">
                <th></th>
                <th>Name of the Company</th>
                <th>Gross Dividend Amount</th>
                <th>Related Expenses</th>
                <th>Net Income</th>
                <th>TDS</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let detail of getInterestSecurityDetails(item); let i = index">
                <td class="text-center">{{ i + 1 }}</td>
                <td>{{ getValue(detail, 'nameOfParticular') }}</td>
                <td class="text-right pr-3">{{ getValue(detail, 'grossInterest') | currencySeparatorBD }}</td>
                <td class="text-right pr-3">{{ getValue(detail, 'relatedExpenses') | currencySeparatorBD }}</td>
                <td class="text-right pr-3">{{ getNetIncome(detail) | currencySeparatorBD }}</td>
                <td class="text-right pr-3">{{ getValue(detail, 'deductedTax') | currencySeparatorBD }}</td>
              </tr>
              <tr class="font-weight-bold">
                <td class="text-center" colspan="2">Total</td>
                <td class="text-right pr-3">{{ getDetailsTotal(getInterestSecurityDetails(item), 'grossInterest') | currencySeparatorBD }}</td>
                <td class="text-right pr-3">{{ getDetailsTotal(getInterestSecurityDetails(item), 'relatedExpenses') | currencySeparatorBD }}</td>
                <td class="text-right pr-3">{{ getDetailsTotalNetIncome(getInterestSecurityDetails(item)) | currencySeparatorBD }}</td>
                <td class="text-right pr-3">{{ getDetailsTotal(getInterestSecurityDetails(item), 'deductedTax') | currencySeparatorBD }}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Other Securities -->
        <div class="col-12" *ngIf="isOtherSecuritiesType(item?.iisTypeName)">
          <table class="table table-bordered income-financial-assets-table">
            <thead>
              <tr class="text-center">
                <th></th>
                <th>Particulars</th>
                <th>Payment Authority</th>
                <th>Date</th>
                <th>Gross Amount Received</th>
                <th>Related Expense</th>
                <th>Net Income</th>
                <th>TDS</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let detail of getInterestSecurityDetails(item); let i = index">
                <td class="text-center">{{ i + 1 }}</td>
                <td>{{ getValue(detail, 'nameOfParticular') }}</td>
                <td>{{ getValue(detail, 'paymentAuthority') }}</td>
                <td>{{ getValue(detail, 'dateOfIssue') }}</td>
                <td class="text-right pr-3">{{ getValue(detail, 'grossInterest') | currencySeparatorBD }}</td>
                <td class="text-right pr-3">{{ getValue(detail, 'relatedExpenses') | currencySeparatorBD }}</td>
                <td class="text-right pr-3">{{ getNetIncome(detail) | currencySeparatorBD }}</td>
                <td class="text-right pr-3">{{ getValue(detail, 'deductedTax') | currencySeparatorBD }}</td>
              </tr>
              <tr class="font-weight-bold">
                <td class="text-center" colspan="4">Total</td>
                <td class="text-right pr-3">{{ getDetailsTotal(getInterestSecurityDetails(item), 'grossInterest') | currencySeparatorBD }}</td>
                <td class="text-right pr-3">{{ getDetailsTotal(getInterestSecurityDetails(item), 'relatedExpenses') | currencySeparatorBD }}</td>
                <td class="text-right pr-3">{{ getDetailsTotalNetIncome(getInterestSecurityDetails(item)) | currencySeparatorBD }}</td>
                <td class="text-right pr-3">{{ getDetailsTotal(getInterestSecurityDetails(item), 'deductedTax') | currencySeparatorBD }}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Bonds and Other Securities -->
        <div class="col-12" *ngIf="isBondsAndSecuritiesType(item?.iisTypeName)">
          <table class="table table-bordered income-financial-assets-table">
            <thead>
              <tr class="text-center">
                <th></th>
                <th>Name of Treasury Bill/Bond</th>
                <th>Issue No</th>
                <th>Issue Date</th>
                <th>Value</th>
                <th>Date of Maturity</th>
                <th>Gross Interest</th>
                <th>TDS</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let detail of getInterestSecurityDetails(item); let i = index">
                <td class="text-center">{{ i + 1 }}</td>
                <td>{{ getValue(detail, 'bondName') }}</td>
                <td>{{ getValue(detail, 'registrationNo') }}</td>
                <td>{{ getValue(detail, 'dateOfIssue') }}</td>
                <td class="text-right pr-3">{{ getValue(detail, 'value') | currencySeparatorBD }}</td>
                <td>{{ getValue(detail, 'dateOfMaturity') }}</td>
                <td class="text-right pr-3">{{ getValue(detail, 'grossInterest') | currencySeparatorBD }}</td>
                <td class="text-right pr-3">{{ getValue(detail, 'deductedTax') | currencySeparatorBD }}</td>
              </tr>
              <tr class="font-weight-bold">
                <td class="text-center" colspan="4">Total</td>
                <td class="text-right pr-3">{{ getDetailsTotal(getInterestSecurityDetails(item), 'value') | currencySeparatorBD }}</td>
                <td></td>
                <td class="text-right pr-3">{{ getDetailsTotal(getInterestSecurityDetails(item), 'grossInterest') | currencySeparatorBD }}</td>
                <td class="text-right pr-3">{{ getDetailsTotal(getInterestSecurityDetails(item), 'deductedTax') | currencySeparatorBD }}</td>
              </tr>
            </tbody>
          </table>
          <!-- <div class="mt-2" *ngIf="hasValue(item, 'totalExpense')">
            <strong>Related Expenses:</strong> {{ getValue(item, 'totalExpense') | currencySeparatorBD }}
          </div> -->
        </div>

        <!-- SUKUK and Sharia -->
        <div class="col-12" *ngIf="isSukukType(item?.iisTypeName)">
          <table class="table table-bordered income-financial-assets-table">
            <thead>
              <tr class="text-center">
                <th></th>
                <th>Name of SUKUK/Sharia</th>
                <th>Issue No</th>
                <th>Issue Date</th>
                <th>Value</th>
                <th>Date of Maturity</th>
                <th>Gross Profit</th>
                <th>TDS</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let detail of getInterestSecurityDetails(item); let i = index">
                <td class="text-center">{{ i + 1 }}</td>
                <td>{{ getValue(detail, 'nameOfParticular') }}</td>
                <td>{{ getValue(detail, 'registrationNo') }}</td>
                <td>{{ getValue(detail, 'dateOfIssue') }}</td>
                <td class="text-right pr-3">{{ getValue(detail, 'value') | currencySeparatorBD }}</td>
                <td>{{ getValue(detail, 'dateOfMaturity') }}</td>
                <td class="text-right pr-3">{{ getValue(detail, 'grossInterest') | currencySeparatorBD }}</td>
                <td class="text-right pr-3">{{ getValue(detail, 'deductedTax') | currencySeparatorBD }}</td>
              </tr>
              <tr class="font-weight-bold">
                <td class="text-center" colspan="4">Total</td>
                <td class="text-right pr-3">{{ getDetailsTotal(getInterestSecurityDetails(item), 'value') | currencySeparatorBD }}</td>
                <td></td>
                <td class="text-right pr-3">{{ getDetailsTotal(getInterestSecurityDetails(item), 'grossInterest') | currencySeparatorBD }}</td>
                <td class="text-right pr-3">{{ getDetailsTotal(getInterestSecurityDetails(item), 'deductedTax') | currencySeparatorBD }}</td>
              </tr>
            </tbody>
          </table>
          <!-- <div class="mt-2" *ngIf="hasValue(item, 'totalExpense')">
            <strong>Related Expenses:</strong> {{ getValue(item, 'totalExpense') | currencySeparatorBD }}
          </div> -->
        </div>
      </div>
    </ng-container>
  </ng-container>
</div>
